import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IDriver } from 'src/core/interfaces/driver';

@Injectable({
  providedIn: 'root'
})
export class DriverService {

  private _baseUrl = `${environment.apiURL}/api`;

  constructor(private http: HttpClient) { }

  // Get all drivers
  getDrivers(include = true) {
    return this.http.get<any>(`${this._baseUrl}/driver`, {
      params: { include: include }
    });
  }

  // Get a driver by ID
  getDriverById(id: number) {
    return this.http.get<any>(`${this._baseUrl}/driver/${id}`);
  }

  // Add a new driver
  addDriver(driver: IDriver) {
    // // debugger;
    const form = new FormData();
    form.append("firstName", driver.firstName);
    form.append("lastName", driver.lastName);
   // form.append("driverId", driver.id.toString());
   form.append("licenseNumber", driver.licenseNumber);
   form.append("nationality", driver.nationality);
   form.append("contactNumber", driver.contactNumber);
   form.append("residenceNumber", driver.residenceNumber);
    form.append("AssignedVehicleId", driver.vehicleId.toString());
    form.append("isSystemUser", driver.isSystemUser ? driver.isSystemUser.toString() : "false");
    form.append("isActive", driver.isActive === true ? "true" : "false");
    if (driver.photoUrl) {
      form.append("ProfilePhoto", driver.photoUrl);
    }
    if (driver.licensePhotoUrl) {
      form.append("LicensePhoto", driver.licensePhotoUrl);
    }
    if (driver.identityPhotoUrl) {
      form.append("IdentityPhoto", driver.identityPhotoUrl);
    }
    return this.http.post<any>(`${this._baseUrl}/driver/add`, form);
  }

  // Update an existing driver
  updateDriver(id: number, driver: IDriver) {
    const form = new FormData();
    
    // Append basic fields
    form.append("firstName", driver.firstName);
    form.append("lastName", driver.lastName);
    form.append("residenceNumber", driver.residenceNumber);
    form.append("licenseNumber", driver.licenseNumber || '');
    form.append("contactNumber", driver.contactNumber || '');
    form.append("nationality", driver.nationality);
    form.append("isSystemUser", driver.isSystemUser?.toString() || 'false');
    form.append("isActive", driver.isActive === true ? "true" : "false");
    
    // Append vehicle ID if exists
    if (driver.vehicleId) {
      form.append("AssignedVehicleId", driver.vehicleId.toString());
    }
    // Append files only if they are actual File objects
    if (driver.photoUrl ) {
      form.append("ProfilePhoto", driver.photoUrl);
    }
    if (driver.licensePhotoUrl ) {
      form.append("LicensePhoto", driver.licensePhotoUrl);
    }
    if (driver.identityPhotoUrl ) {
      form.append("IdentityPhoto", driver.identityPhotoUrl);
    }

    return this.http.patch<any>(`${this._baseUrl}/driver/${id}`, form);
  }
  createDriverUserAccount(driverId: number, userData: {
    userName: string;
    email: string;
    password: string;
    confirmPassword: string;
  }) {
    // Send as JSON instead of FormData
    return this.http.post<any>(
      `${this._baseUrl}/Driver/CreateDriverUser/${driverId}`, 
      userData, 
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
  }
  // Delete a driver by ID
  deleteDriver(id: number) {
    return this.http.delete<any>(`${this._baseUrl}/driver/${id}`);
  }

  // Delete multiple drivers by IDs
  deleteDrivers(ids: number[]) {
    return this.http.delete<any>(`${this._baseUrl}/driver/delete/range`, { body: ids });
  }

  // Get paginated drivers
  getPaginatedDrivers(pageIndex = 0, pageSize = 10, pagination = false, criteria = null, isActive = -1) {
    return this.http.get<any>(`${this._baseUrl}/driver/paginated/${isActive}?pageIndex=${pageIndex}&pageSize=${pageSize}&pagination=${pagination}${criteria ? "&criteria=" + criteria : ""}`);
  }
}
